
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TagInput } from '@/components/ui/tag-input';

interface NoteFiltersProps {
  selectedTags: string[];
  onTagsChange: (tags: string[]) => void;
  sortBy: string;
  onSortChange: (value: string) => void;
  availableTags: string[];
}

const NoteFilters: React.FC<NoteFiltersProps> = ({
  selectedTags = [],
  onTagsChange,
  sortBy,
  onSortChange,
  availableTags = [],
}) => {
  const tagOptions = (availableTags || []).map(tag => ({ label: tag, value: tag }));

  return (
    <div className="flex flex-col md:flex-row gap-4 mb-4">
      <div className="flex-1">
        <TagInput
          placeholder="Filter by tags..."
          selected={selectedTags || []}
          options={tagOptions}
          onChange={onTagsChange}
        />
      </div>
      <Select value={sortBy} onValueChange={onSortChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="newest">Newest First</SelectItem>
          <SelectItem value="oldest">Oldest First</SelectItem>
          <SelectItem value="updated">Last Updated</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default NoteFilters;
